(function () {
  const sentinels = [];

  function addSentinel(section) {
    const sentinel = document.createElement('div');
    sentinel.dataset.forSection = section.id;
    sentinel.style.cssText = `display: block; position: relative; top: ${section.offsetHeight / 2}px;`;
    section.parentElement.insertBefore(sentinel, section);
    sentinels.push(sentinel);
  }

  function handleLighting(entry, section) {
    let target = section ?? entry.target;

    if (entry.isIntersecting) {
      target.style.setProperty('filter', 'brightness(1)');
    } else {
      target.style.setProperty('filter', 'brightness(0.5)');
    }
  }

  function initGiSections(giSections) {
    if (!giSections.length) return;

    // dim/undim based on section visibility
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => handleLighting(entry));
      },
      { threshold: 0.5 }
    );

    giSections.forEach((section, index) => {
      if (section.classList.contains('gi-fullscreen-media-section')) {
        section.style.setProperty('position', 'sticky');
        section.style.setProperty('bottom', 0);
        addSentinel(section);
      } else {
        section.style.setProperty('position', 'relative');
        io.observe(section);
      }
      section.style.setProperty('z-index', giSections.length - index + 5);

      if (index > 0) section.style.setProperty('filter', 'brightness(0.5)');
    });
  }

  class FullscreenMedia {
    constructor() {
      this.fullscreenMedias = document.querySelectorAll('.gi-fullscreen-media');
      this.currentPlayingVideo = null;
      this.mobileQuery = window.matchMedia('(max-width: 767px)');

      if (this.fullscreenMedias.length > 0) {
        this.init();
      }
    }

    init() {
      this.fullscreenMedias.forEach((fullscreenMedia) => {
        this.initVideoEventListeners(fullscreenMedia);
        this.initControlButtons(fullscreenMedia);
        this.applyVideoSource(fullscreenMedia);
      });

      this.mobileQuery.addEventListener('change', () => {
        this.fullscreenMedias.forEach((fullscreenMedia) => this.applyVideoSource(fullscreenMedia));
      });
    }

    applyVideoSource(fullscreenMedia) {
      const video = fullscreenMedia.querySelector('.gi-fullscreen-media__video');
      const { src, srcMobile, poster, posterMobile } = video.dataset;
      const nextSrc = (this.mobileQuery.matches ? srcMobile : src) || src;
      const nextPoster = (this.mobileQuery.matches ? posterMobile : poster) || poster;

      if (!nextSrc || video.getAttribute('src') === nextSrc) return;

      const wasPlaying = !video.paused;
      video.poster = nextPoster || '';
      video.src = nextSrc;
      video.load();
      if (wasPlaying) video.play().catch(() => {});
    }

    initVideoEventListeners(fullscreenMedia) {
      const video = fullscreenMedia.querySelector('.gi-fullscreen-media__video');

      video.addEventListener('play', () => {
        fullscreenMedia.classList.add('is-playing');
      });

      video.addEventListener('pause', () => {
        fullscreenMedia.classList.remove('is-playing');
      });

      video.addEventListener('volumechange', () => {
        if (video.muted) {
          fullscreenMedia.classList.add('is-muted');
        } else {
          fullscreenMedia.classList.remove('is-muted');
        }
      });
    }

    initControlButtons(fullscreenMedia) {
      const video = fullscreenMedia.querySelector('.gi-fullscreen-media__video');
      const playButton = fullscreenMedia.querySelector('.gi-fullscreen-media__playback-button');
      const soundButton = fullscreenMedia.querySelector('.gi-fullscreen-media__sound-button');

      playButton.addEventListener('click', () => {
        if (video.paused) {
          video.play().then(() => (this.currentPlayingVideo = video));
          fullscreenMedia.classList.remove('force-paused');
        } else {
          video.pause();
          fullscreenMedia.classList.add('force-paused');
        }
      });

      soundButton?.addEventListener('click', () => (video.muted = !video.muted));
    }

    handleIntersection(entry, section) {
      const fullscreenMedia = section.querySelector('.gi-fullscreen-media');
      const video = fullscreenMedia.querySelector('.gi-fullscreen-media__video');

      if (entry.isIntersecting) {
        fullscreenMedia.classList.add('is-visible');

        if (this.currentPlayingVideo && this.currentPlayingVideo !== video) {
          this.currentPlayingVideo.pause();
          this.currentPlayingVideo = null;
        }

        if (fullscreenMedia.classList.contains('force-paused')) {
          return;
        }

        video.play().then(() => {
          this.currentPlayingVideo = video;
        });
      } else {
        fullscreenMedia.classList.remove('is-visible');

        if (video === this.currentPlayingVideo) {
          this.currentPlayingVideo = null;
        }
        video.pause();
      }
    }
  }

  function initGiSentinelsObserver(fullscreenMedia) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const section = document.getElementById(entry.target.dataset.forSection);
          fullscreenMedia.handleIntersection(entry, section);
          handleLighting(entry, section);
        });
      },
      { delay: 200 }
    );

    sentinels.forEach((sentinel) => observer.observe(sentinel));
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (Shopify.designMode) return;

    initGiSections(document.querySelectorAll('.gi-section'));
    initGiSentinelsObserver(new FullscreenMedia());
  });
})();
